import { render } from "./LoginInit.vue?vue&type=template&id=88e0fc70"
import script from "./LoginInit.vue?vue&type=script&lang=js"
export * from "./LoginInit.vue?vue&type=script&lang=js"

import exportComponent from "C:\\8 Extension Folder\\8.0 Extension Folder\\8.02\\SMMPortfolioSite\\photographydays-login\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__